import { FormValidationDefinition } from "commons/form/useForm";
import registerValidationService from "../../common/register-validation-service";
import formValidationService from "commons/form/form-validation.service";
import DispatcherRegisterFormData from "./dispatcher-register-form-data";

const getEmptyFormData = (): DispatcherRegisterFormData => {
  return {
    name: "",
    surname: "",
    email: "",
    phone: "",
    login: "",
    loginCheck: {
      available: true,
      login: "",
    },
    password: "",
    passwordConfirm: "",
    companyId: "",
    companyName: "",
  };
};

const getFormValidationDefinition = (): FormValidationDefinition<DispatcherRegisterFormData> => {
  return {
    email: (values) => registerValidationService.validateEmail(values.email),
    login: (values) => registerValidationService.validateLogin(values.login, values.loginCheck),
    loginCheck: formValidationService.ok,
    name: (values) => registerValidationService.validateName(values.name),
    password: (values) => formValidationService.validatePassword(values.password, true),
    passwordConfirm: (values) => formValidationService.validatePasswordConfirm(values.password, values.passwordConfirm),
    phone: (values) => registerValidationService.validatePhone(values.phone),
    surname: (values) => registerValidationService.validateSurname(values.surname),
    companyId: formValidationService.ok,
    companyName: (values) => registerValidationService.validateCompanyName(values.companyName),
  };
};

const dispatcherRegisterFormFactory = {
  getEmptyFormData,
  getFormValidationDefinition,
};

export default dispatcherRegisterFormFactory;
